import { ConfigurationStoreState, useConfigurationStore } from '@stores/configurationStore'
import { Slot } from '@utils/Slot'
import React, { ReactNode } from 'react'
import { ICommonJackpotConfig } from '../common/types'
import { ViewportType } from 'game-ui-types'
import { cn } from '@amusnet/react-ui'

interface JackpotStatisticsProps {
    config: ICommonJackpotConfig // Jackpot specific config
    children: ReactNode[]
}

/**
 * JackpotStatistics Component
 *
 * Handles template of all jackpot statistic panels split in two rows and a logo in the middle in portrait, and all in a row in landscape.
 * "top", "bottom" and "logo" Slots available so specific statistics item panels are rendered according to jackpot.
 */
const JackpotStatisticsEQ: React.FC<JackpotStatisticsProps> = ({ config, children }) => {
    const viewport = useConfigurationStore((state: ConfigurationStoreState) => state.viewport)
    const viewportConfig = config[viewport]

    const { jackpotStatistics: statsConfig } = viewportConfig

    const jackpotStatsClasses = cn('w-full h-auto', {
        'flex justify-between': viewport !== ViewportType.MOBILE_PORTRAIT,
    })

    const topRowClasses = cn('flex w-full z-[3] relative', {
        'justify-between w-full': viewport === ViewportType.MOBILE_PORTRAIT,
    })
    const topRowStyle = {
        marginBottom: `${statsConfig.topRowMargin?.bottom ?? 0}px`,
    }

    const bottomRowClass = cn('flex w-full z-[2] relative', {
        'justify-end': viewport !== ViewportType.MOBILE_PORTRAIT,
        'justify-between': viewport === ViewportType.MOBILE_PORTRAIT,
    })

    return (
        <div className={jackpotStatsClasses}>
            <div className={topRowClasses} style={topRowStyle}>
                <Slot slot="top">{children}</Slot>
            </div>

            <Slot slot="logo">{children}</Slot>

            <div className={bottomRowClass}>
                <Slot slot="bottom">{children}</Slot>
            </div>
        </div>
    )
}

export default JackpotStatisticsEQ
